// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"4df6965d","224":"6a3d24d5"}[chunkId] + ".chunk.css";
};